import { inspectWav } from './wav';
export const AUDIO_ACCEPT = '.wav,.m4a,.mp3,.aac,audio/wav,audio/x-wav,audio/mp4,audio/x-m4a,audio/mpeg,audio/aac';
export function audioFormat(name: string, bytes?: ArrayBuffer): 'wav' | 'm4a' | 'mp3' | 'aac' {
  const extension = name.toLowerCase().split('.').pop();
  if (!['wav','m4a','mp3','aac'].includes(extension ?? '')) throw new Error('Select WAV, M4A (AAC), MP3, or AAC audio.');
  if (bytes) {
    if (bytes.byteLength < 12) throw new Error('Audio file is empty or incomplete.');
    if (extension === 'wav') inspectWav(bytes);
  }
  return extension as 'wav' | 'm4a' | 'mp3' | 'aac';
}
export function decodedByteSize(buffer: { length: number; numberOfChannels: number }): number { return buffer.length * buffer.numberOfChannels * 4; }
